"use client";

import Image from "next/image";
import React, { useEffect, useState } from "react";


export default function HomeSlide({ data }) {
  const [index, setIndex] = useState(0);

  const banners = data?.contentAttachments1.map(item => {
    const hasImage = item?.attachFiles?.mediaCdnUrl || null;
    if(hasImage) {
      return {
        src: hasImage,
        title: item?.attachField1 || '',
        description: item?.attachField2 || ''
      }
    }

    return false;
  }).filter(f => f !== false) || [];

  // Slideshow automático
  useEffect(() => {
    const timer = setTimeout(() => {
      setIndex((prev) => (prev + 1) % banners.length);
    }, 4000);
    return () => clearTimeout(timer);
  }, [index]);


  return (
    <section className="relative overflow-hidden h-[1000px] w-full">
      {banners.map((item, i) => (
        <div 
          key={i}
          className={`absolute w-full h-full object-cover transition-opacity duration-1000 ease-in-out ${
            index === i ? "opacity-100" : "opacity-0"
          }`}
          >
          <Image
            src={item.src}
            alt={item.title}
            fill
            sizes="100vw"
          />

          { item.title && item.description && (
            <div className="absolute left-[10%] top-1/2 -translate-y-1/2 bg-blue-900/80 rounded-2xl px-10 py-8 max-w-[500px] text-left shadow-xl animate-fadeIn">
              { item.title  && (
                <h2 className="text-white text-[32px] font-bold leading-tight mb-3">
                  { item.title }
                </h2>
              )}

              { item.description && (
                <div className="text-white text-[16px] leading-snug">
                  { item.description }
                </div>
              )}
            </div>
          )}
        </div>
      ))}
    </section>
  );
}
